import React from 'react'

import {
  AccordionContentContainer,
  AccordionContentHeader,
  AccordionContentText,
} from './styled-components'

type Props = {
  header: string
  text: string
}

const AccordionContent: React.SFC<Props> = ({ header, text }) => (
  <AccordionContentContainer>
    <AccordionContentHeader>{header}</AccordionContentHeader>
    <AccordionContentText>{text}</AccordionContentText>
  </AccordionContentContainer>
)

export default AccordionContent
